import { Asterisk } from "lucide-react";

interface MarqueeProps {
  items: string[];
  variant?: "ink" | "blaze" | "ivory";
  reverse?: boolean;
}

/** Brutalist scrolling typographic ticker. */
export function Marquee({ items, variant = "ink", reverse = false }: MarqueeProps) {
  const palette =
    variant === "blaze"
      ? "text-[var(--accent)] border-y border-[var(--surface-muted)]/40"
      : variant === "ivory"
        ? "text-foreground/70 border-y border-[var(--surface-muted)]/40"
        : "text-foreground/55 border-y border-[var(--surface-muted)]/40";

  // Duplicate twice for seamless loop (translateX -50%)
  const loop = [...items, ...items];

  return (
    <div className={`marquee ${palette} py-3 md:py-4`} aria-hidden>
      <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
        {loop.map((label, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-xl font-semibold uppercase tracking-[0.04em] md:text-3xl">
              {label}
            </span>
            <Asterisk size={16} strokeWidth={2} className="opacity-50 text-[var(--accent)]" />
          </span>
        ))}
      </div>
    </div>
  );
}
